var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestionBullet = function SvgQuestionBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M750.08 482.24c-14.957-119.307-115.767-210.687-237.92-210.687s-222.963 91.38-237.799 209.51l-.121 1.178q0 9.92-1.92 20.16v249.6h249.6c128.294-5.369 230.267-110.677 230.267-239.803 0-3.333-.068-6.65-.203-9.951l.015.473c.227-3.016.356-6.533.356-10.08s-.129-7.064-.384-10.546l.027.466z"
  })));
};
export default SvgQuestionBullet;